import './list.css';
import { Card } from '../Card/Card';
import CardNull from '../../assets/NoCard.png';

export const List = ({listTransactions, setListTransactions}) =>{

    return(
        <>
            <h2 className='title-list'>Resumo financeiro</h2>
            <ul className='container-list'>
                {listTransactions.length === 0 ? 
                <li> 
                    <h2> Você ainda não possui nenhum lançamento </h2>
                    <div className='img-cardNull'>
                        <img src={CardNull} alt='cardNull' />
                        <img src={CardNull} alt='cardNull' />
                        <img src={CardNull} alt='cardNull' />
                    </div>
                
                </li>

                : 
                
                listTransactions.map((transaction) => <Card transaction={transaction} 
                listTransactions={listTransactions} setListTransactions={setListTransactions} key={transaction.id}/>)
                
                }

            </ul>
        
        </>

    )
}
